import type { FeatureName } from "@lib/featureFlipper";

import type { ComponentFeatureFlippers } from "../types";

/**
 * This method is used to determine if a feature flipper is a string or an object with an OR property.
 *
 * @param feature The feature flipper to check
 * @returns boolean indicating if the feature flipper is a string
 */
export const isFeatureString = (feature: ComponentFeatureFlippers): feature is FeatureName => {
  return typeof feature === "string";
};
